import React, { useState } from "react";
import {
  ChevronRight,
  infoOutlineMini,
  TickOutlineMini,
} from "../../assets/SvgIcons";

const Step8 = ({
  handleNextStep,
  data,
  priceData,
  formData2,
  firstImg,
  secondImg,
  selected,
  images,
  conditionSelected,
}) => {
  const [stepsListing, setStepListing] = useState([
    {
      stepName: "Listing Title",
      isOptional: true,
      isComplete: true,
      stepNo: 1,
    },
    {
      stepName: "Watch Details",
      isOptional: false,
      isComplete: true,
      stepNo: 2,
    },
    {
      stepName: "Scope of delivery",
      isOptional: false,
      isComplete: selected !== null,
      stepNo: 3,
    },
    {
      stepName: "Photos",
      isOptional: false,
      isComplete: images?.length > 0,
      stepNo: 4,
    },
    {
      stepName: "Proof of Ownership",
      isOptional: false,
      isComplete: firstImg !== null && secondImg !== null,
      stepNo: 5,
    },
    {
      stepName: "Condition",
      isOptional: false,
      isComplete: conditionSelected !== null,
      stepNo: 6,
    },
    { stepName: "Sales price", isOptional: false, isComplete: true, stepNo: 7 },
  ]);
  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
        Overview of Your Listing
      </h1>
      <p className="text-[14px] mt-4 mb-8">
        Review and refine all details to maximize your chances of selling your
        watch.
      </p>
      <div className="text-[14px]">
        <p className="font-medium mb-6">Basic Information About Your Watch</p>
        <p className="bg-primarylight p-4 rounded-lg">
          Please enter the missing information so we can publish your listing.
        </p>
      </div>{" "}
      <div className="p-4 rounded-lg flex gap-6 border mt-8">
        <img
          src={data.imageUrl}
          alt=""
          width={120}
          height={120}
          className="border  rounded-lg"
        />
        <div className="w-full  flex flex-col justify-between">
          <p className="text-xl">{data.title}</p>

          <div>
            <p className="text-lg">
              Dealer - {priceData.currency} {priceData.price}
            </p>

            <p className="text-lg">
              End User - {priceData.currency2} {priceData.price2}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8">
        {stepsListing?.map((step, index) => {
          return (
            <div
              key={index}
              onClick={() => handleNextStep(step?.stepNo)}
              className={`cursor-pointer flex justify-between items-center gap-4 py-3 border-b `}
            >
              <div className="flex gap-1.5 items-center">
                {step?.isComplete ? (
                  <span className="text-green-600">{TickOutlineMini}</span>
                ) : (
                  <span className="text-red-600">{infoOutlineMini}</span>
                )}
                <p className="text-[14px]">{step?.stepName}</p>
              </div>
              <div className="flex gap-1.5 items-center">
                {" "}
                {step?.isOptional && (
                  <p className="text-[14px]">(optional)</p>
                )}{" "}
                {ChevronRight}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Step8;
